import {
  INVENTORY_SET_INVENTORY_SETTINGS,
  INVENTORY_REQUEST_INVENTORY_SETTINGS,
} from './constants';

import type { Settings } from './types';

export const requestAdvancedInventorySettings = () => {
  return {
    type: INVENTORY_REQUEST_INVENTORY_SETTINGS,
  };
};

export const setAdvancedInventorySettings = (settings: Settings) => {
  return {
    type: INVENTORY_SET_INVENTORY_SETTINGS,
    payload: { settings },
  };
};
